
































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import SideTabRight from "@/components/SideTabRight.vue";
import requestService from "@/service/requestService";
import { SeibiItem, InspectionItem } from "@/model/InspectionSeibi";
import { Action, Getter } from "vuex-class";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import UserFooter from "@/components/UserFooter.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import { HikazeiRyoukin, Hikazei3 } from "@/model/RyoukinRank";
import { ElForm } from "element-ui/types/form";
import { ShakenShohiyou } from "@/model/shakenShohiyou";

@Component({
  components: {
    appSideTabRight: SideTabRight,
    ConfirmDialog,
    UserFooter
  },
  beforeRouteEnter (to, from, next) {
    if (from.path.indexOf("/workdetail") == -1){
      window.localStorage.removeItem("statusResultTab");
    }
    next();
  },
})
export default class StatusResult extends Vue {
  @Action("setSeibiData", { namespace: "InspectSeibi" })
  setSeibiData: any;

  @Getter("hasData", { namespace: "InspectSeibi" })
  hasData: boolean;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationDetail: any;
  @Action("updateRyoukinRankCd", { namespace: "ReservationDetail" })
  updateRyoukinRankCd: any;

  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  @Getter("hasData", { namespace: "InspectSeibiAK3" })
  hasDataAK3: boolean;

  @Getter("listInspectAll", { namespace: "InspectSeibiAK3" })
  listInspect!: InspectionItem[];

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("seibiAK3Loading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("seibiError", { namespace: "UserDataState" })
  seibiError: string;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;

  @Action("updateInspect", { namespace: "InspectSeibiAK3" })
  updateInspect: any;

  @Action("updateDoTenken", { namespace: "InspectSeibiAK3" })
  updateDoTenken: any;

  @Action("updateInspectDoTenken", { namespace: "InspectSeibi" })
  updateInspectDoTenken: any;

  @Action("updateDoTenkenFromSocket", { namespace: "InspectSeibi" })
  updateDoTenkenFromSocket: any;

  @Action("updateTax", { namespace: "Shohiyou" })
  updateTax: any;

  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;

  public showAside: boolean = true;
  public currentTab: number = 1;

  public reqService: requestService;
  sktControll: SocketControllers;
  public checkList: any[] = [];
  loadingText: string = MESSAGE.Loading;
  errorMsg: string = "";
  isSave: boolean = false;
  displayDialogTax: boolean = false;
  isSetFormData: boolean = false;
  formData: JuuryouzeiJibaiseikiSave = {
    zeiJibaisekiMonthCnt: null,
    zkJibaisekiCd: null,
    zeiJibaisekiZn: null,
    zeiJibaisekiZk: null,
    zkWeightTaxCd: null,
    zeiWeightTax: null,
    zeiInshidaiZn: null,
    zeiInshidaiZk: null,
    zeiInshidaiGenka: null,
    ryoukinRankCd: null
  };
  listRyoukinRank: HikazeiRyoukin = { hikazei3: [], ryoukinRank: [] };
  rules = {
    zeiInshidaiZn: [{ validator: this.validateInshidai }],
    ryoukinRankCd: [{ validator: this.validateRyoukinRank }]
  };
  // 2022-01-31 morisako kobac-free mod [START]
  freeOfChargeNm: string = '無償対応';
  // 2022-01-31 morisako kobac-free mod [END]

  $refs!: {
    errorDialog: ConfirmDialog;
    sideTab: SideTabRight;
    taxForm: ElForm;
  };

  get isError() {
    return this.seibiError != "";
  }

  oncloseError() {
    this.setError({ key: "seibi", value: "" });
  }

  get seibiAK3Length(): number[] {
    if (this.listInspect.length > 0) {
      return this.listInspect.map((e: any, index: number) => e.length);
    }
    return [0, 0, 0];
  }

  created() {
    this.$emit("onTopTitle", "検査結果");
    this.sktControll = new SocketControllers();
    this.sktControll.connectSocket(this.onConnect);

    if (window.localStorage.statusResultTab) {
      this.currentTab = +window.localStorage.statusResultTab;
    }
    this.getSeibi();
    if (!this.reservationDetail.sknUketsukeExtends || !this.reservationDetail.sknUketsukeExtends.ryoukinRankCd) {
      this.onShowTax(true);
    }
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
  }

  // @Watch("listInspect")
  // onChangeVal() {
  //   if (this.listInspect && this.listInspect[1]) {
  //     let tempData: any = JSON.parse(JSON.stringify(this.listInspect[1]));
  //     this.loopFirstDoTenken(tempData);
  //   }
  // }

  // loopFirstDoTenken(tempData: any) {
  //   if (tempData.length > 0) {
  //     tempData.forEach((element: any) => {
  //       this.firstDoTenken(element, 1);
  //     });
  //   }
  // }

  getSeibi() {
    this.reqService = new requestService();
    const userService = new UserService();
    if (!this.hasDataAK3 && !this.isLoading) {
      if (!this.reservationDetail.sknUketsukeExtends || !this.reservationDetail.sknUketsukeExtends.ryoukinRankCd) {
        userService.getAllData(false);
      } else {
        userService.getAllData();
      }
    } else {
      userService.getSeibiAK3();
    }
  }

  onError(res: any) {
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  isActive(index: number) {
    return this.currentTab === index;
  }

  selectTab(tab: number) {
    this.currentTab = tab;
    window.localStorage.statusResultTab = this.currentTab;
  }

  onConnect() {
    if (this.sktControll.checkSocket()) {
      this.sktControll.socketInspect(this.onInspectItemcompleted);
      //this.sktControll.socketInspectSeibi(this.onSeibiItemcompleted);
      this.sktControll.socketInspections(this.onInspectionDotenken);
    }
  }

  onInspectItemcompleted(frame: any) {
  //  const body = util.getWSData(frame);
  //  const seibi = { ...body };
  //  delete seibi.sknWorkProgressState;
  //  delete seibi.sknWorkProgressStateNm;
  //  this.setSeibiAK3Data(seibi);
    this.notify();
    // this.loopFirstDoTenken(this.listInspect[1]);
  }

//  onSeibiItemcompleted(frame: any) {
//    const body = util.getWSData(frame);
//    const seibi = { ...body };
///    delete seibi.items.sknWorkProgressState;
//    delete seibi.items.sknWorkProgressStateNm;
//    this.setSeibiData(seibi);
//  }

  onInspectionDotenken(frame: any) {
    if (this.isSave) {
      this.isSave = false;
    } else {
      this.notify();
      const body = util.getWSData(frame);
      this.updateDoTenken(body);
      this.updateDoTenkenFromSocket(body);
    }
    this.updateSideTab();
    this.$forceUpdate();
  }

  updateSideTab() {
    if (this.$refs.sideTab) {
      this.$refs.sideTab.onUpdate(2);
      this.$refs.sideTab.onUpdate(3);
      this.$forceUpdate();
    } else {
      setTimeout(() => {
        this.updateSideTab();
      }, 300);
    }
  }

  notify() {
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedInspections
    });
  }

  openWorkDetail(inspectItem: InspectionItem, index: number) {
    if (inspectItem.sknInspectId) {
      this.$router.push({
        name: "workdetail",
        query: {
          inspect: inspectItem.sknInspectId.toString(),
          index: index.toString()
        }
      });
    }
  }

  onImgError(item: InspectionItem) {
    item.img[0] = "";
    this.updateInspect(item);
    this.$forceUpdate();
  }

  changeDoTenken(item: InspectionItem, doTenken: any) {
    if (item.doTenken != doTenken) {
      item.doTenken = doTenken;
      this.updateInspect(item);
      this.updateInspectDoTenken(item);
      this.$forceUpdate();
      this.isSave = true;
      this.reqService.updateDoTenken(
        this.uketsukeExtendsId,
        doTenken,
        item.sknInspectId
      ).then((res) => {
        const userService = new UserService();
        userService.autoSaveAk7();
      });
    }
  }

  // firstDoTenken(item: InspectionItem, doTenken: any) {
  //   if (item.doTenken === 0) {
  //     item.doTenken = doTenken;
  //     this.updateDoTenken(item);
  //     this.updateInspectDoTenken(item);
  //     this.$forceUpdate();
  //     this.isSave = true;
  //     this.reqService.updateDoTenken(
  //       this.uketsukeExtendsId,
  //       doTenken,
  //       item.sknInspectId
  //     );
  //   }
  // }

  validateInshidai(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidInshidai));
    } else {
      callback();
    }
  }

  validateRyoukinRank(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidRyoukinRank));
    } else {
      callback();
    }
  }

  ryoukinLabel(ryoukin: Hikazei3) {
    return (
      util.getNumberThousandSeparate(ryoukin.hikazei3Kingaku) +
      "円"
    );
  }

  onTaxDialogOpened() {
    this.$refs.taxForm.validate();
  }

  onShowTax(isShow: boolean) {
    this.displayDialogTax = isShow;
    if (isShow && !this.isSetFormData) {
      this.isSetFormData = true;
      this.reqService.getRyoukinRank().then(res => {
        if (res) {
          this.listRyoukinRank = res as HikazeiRyoukin;
        }
      });
      if (this.costData.houteiHiyou) {
        const houteiHiyou = this.costData.houteiHiyou;
        this.formData.zeiJibaisekiZk = houteiHiyou.zeiJibaisekiZk;
        this.formData.zeiJibaisekiZn = houteiHiyou.zeiJibaisekiZn;
        this.formData.zkJibaisekiCd = houteiHiyou.jibaisekiCd;
        this.formData.zeiJibaisekiMonthCnt = houteiHiyou.zeiJibaisekiMonthCnt;
        this.formData.zeiWeightTax = houteiHiyou.zeiWeightTax;
        this.formData.zkWeightTaxCd = houteiHiyou.weightTaxCd;
        this.formData.ryoukinRankCd = houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null;
        this.formData.zeiInshidaiZn = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZk = houteiHiyou.zeiInshidaiZk;
        this.formData.zeiInshidaiGenka = houteiHiyou.zeiInshidaiZn;
      }
      setTimeout(() => {
        this.onTaxDialogOpened();
      }, 500);
    }
  }

  setInshidai() {
    this.formData.zeiInshidaiZk = this.formData.zeiInshidaiZn;
    this.formData.zeiInshidaiGenka = this.formData.zeiInshidaiZn;
  }

  setRyoukinRank() {
    const ryoukin = this.listRyoukinRank.ryoukinRank.filter((data: any) => data.ryoukinRankCd == this.formData.ryoukinRankCd);
    if (ryoukin.length !== 0) {
      this.formData.zeiInshidaiZn = ryoukin[0].hikazei3Kingaku;
      this.formData.zeiInshidaiZk = this.formData.zeiInshidaiZn;
      this.formData.zeiInshidaiGenka = this.formData.zeiInshidaiZn;
    }
  }

  onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.displayDialogTax = false;
        this.formData.zeiInshidaiZk = this.formData.zeiInshidaiZn;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
          // ,
          // zeiJibaisekiMonthCnt: null,
          // zkJibaisekiCd: null,
          // zeiJibaisekiZn: null,
          // zeiJibaisekiZk: null,
          // zkWeightTaxCd: null,
          // zeiWeightTax: null
        };
        this.updateTax(this.formData);
        //this.reqService.saveTax(data);
        this.reqService.saveRyoukinRank(data);
        this.updateRyoukinRankCd(this.formData.ryoukinRankCd);
        setTimeout(() => {
          const userService = new UserService();
          userService.getShohiyou();
        }, 500);
      }
    });
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }
  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) {
        this.freeOfChargeNm = res.freeOfChargeNm;
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
  hasMultipleBuhin(subItem: any) {
    if (subItem && subItem.hasOwnProperty("isHasMultipleBuhin") && subItem.isHasMultipleBuhin == 1) {
      return "";
    }
    return "d_ni";
  }
  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
}
